import { TextLink as AlphaTextLink } from '@oneaudi/unified-web-alpha-components';

export default AlphaTextLink;
